import { useState } from "react";

type DownloadStatus = "idle" | "downloading" | "downloaded" | "error";

interface IFileDownloader {
    downloadFile: (input: Blob | File, fileName: string) => Promise<boolean>;
    status: DownloadStatus;
    isIdle: boolean;
    isDownloading: boolean;
    isDownloaded: boolean;
    isError: boolean;
}

export const useFileDownloader = (): IFileDownloader => {
    const [status, setStatus] = useState<DownloadStatus>("idle");

    const getBlob = (input: Blob | File): Promise<Blob> => {
        if (!("name" in input) && !("size" in input)) {
            setStatus("error");
            return Promise.reject(new Error("Invalid input: Expected a Blob or File."));
        }
        return "name" in input ? Promise.resolve(input) : Promise.resolve(new Blob([input], { type: input.type }));
    };

    const downloadFile = async (input: Blob | File, fileName: string): Promise<boolean> =>
        await getBlob(input)
            .then((blob: Blob) => {
                setStatus("downloading");

                const link = document.createElement("a");
                link.href = URL.createObjectURL(blob);
                link.download = fileName;
                document.body.appendChild(link);

                link.click();
                document.body.removeChild(link);

                setStatus("downloaded");
                return Promise.resolve(true);
            })
            .catch((err) => {
                setStatus("error");
                return Promise.reject(err);
            });

    return {
        downloadFile,
        isDownloaded: status === "downloaded",
        isDownloading: status === "downloading",
        isError: status === "error",
        isIdle: status === "idle",
        status,
    };
};
